import { applyMiddleware, combineReducers, compose, createStore, Reducer } from "redux";
import thunk from "redux-thunk";
import reducers from "../reducers";
import { AppActions } from "../../types";

const createBrowserHistory = require("history").createBrowserHistory;
const history = createBrowserHistory();
type ReducerState<ReducerType> = ReducerType extends (
  ...args: any[]
) => infer State
  ? State
  : never;

export type AppState = {
  [Key in keyof typeof reducers]: ReducerState<(typeof reducers)[Key]>;
};

const rootReducer = combineReducers({
  ...reducers,
}) as unknown as Reducer<AppState, AppActions>;

export default function configureStore(initialState?: AppState) {
  const enhancers: any[] = [];

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(thunk), ...enhancers)
  );
}

export { history };
